import React, { useEffect, useState } from 'react';
import { ServiceableBannerService } from '../../../../common/services';

const BannerItem = ({ data }) => {
  return (
    <>
      {
        data.map((item, index) => (
          <div class="banner-item">
            <a href={item.banner_url} target={item.banner_target}>
              <img src={item.banenr_real_path} alt={item.banner_title} />
            </a>
          </div>
        ))
      }
    </>
  )
};

const BannerList = ({ space }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    ServiceableBannerService.getList(space).then((res) => {
      setData(res.data);
    });
    return () => { };
  }, []);

  return (
    <>


      <div id='stats_banners'>

        <div className='banner-title'>
          <b>네임드 게임 플레이 사이트 안내</b>
          <br/>
          네임드 게임을 플레이할 수 있는 사이트에 대한정보를 제공하는 페이지입니다.
        </div>

        <div className="banner-container">
          {data.length > 0 && (<BannerItem data={data} />)}
        </div>
      </div>
    </>
  );
};

export { BannerList };
